import React, { useEffect, useState } from 'react';
import { InputNumber, Select, Space } from 'antd';
const { Option } = Select;

interface ClientMaxBodySizeInputProps {
    value?: string;
    onChange?: (value: string) => void;
}

const ClientMaxBodySizeInput: React.FC<ClientMaxBodySizeInputProps> = ({ value, onChange }) => {
    // 内部状态，用于拆分数字和单位
    const [size, setSize] = useState<string>('');
    const [unit, setUnit] = useState<string>('m');

    // 当 value 变化时，解析出 size 和 unit
    useEffect(() => {
        if (value) {
            const matches = value.match(/(\d+)([kKmMgG]?[bB]?)/);
            if (matches) {
                setSize(matches[1]);
                setUnit(matches[2].toLowerCase());
            } else {
                setSize('');
                setUnit('m');
            }
        } else {
            setSize('');
            setUnit('m');
        }
    }, [value]);

    // 当任一输入变化时，合并后调用 onChange
    const triggerChange = (changed: { size?: string; unit?: string }) => {
        const newSize = changed.size !== undefined ? changed.size : size;
        const newUnit = changed.unit !== undefined ? changed.unit : unit;
        if (onChange) {
            onChange(`${newSize}${newUnit}`);
        }
    };

    return (
        <Space align="baseline">
            <InputNumber
                value={size ? Number(size) : undefined}
                onChange={(val) => {
                    const newSize = val !== null ? String(val) : '';
                    setSize(newSize);
                    triggerChange({ size: newSize });
                }}
            />
            <Select
                value={unit}
                onChange={(val) => {
                    setUnit(val);
                    triggerChange({ unit: val });
                }}
                style={{ width: 80 }}
            >
                <Option value="k">KB</Option>
                <Option value="m">MB</Option>
                <Option value="g">GB</Option>
            </Select>
        </Space>
    );
};

export default ClientMaxBodySizeInput;
